import { RectSize } from "../../utils/RectSize";

export class ScrollPaneContent
    extends Phaser.GameObjects.Container {
    protected size: RectSize;


    public Init(): void {
        this.size = new RectSize();
    }

    public SetSize(size: RectSize): void;
    public SetSize(width: number, height?: number): void;
    public SetSize(a: any, b: any = undefined): void {
        // its (width, height) overload
        if (b != undefined) {
            this.size.Set(a, b);
        }
        // else its RectSize overload
        else {
            this.size.Set(a);
        }
    }

    public GetSize(): RectSize {
        return this.size;
    }

    /**
     * This generic function collects all items within this container tree, recursively.
     * This could be made a Container extension method (once its ironed out).
     */
    public GetCullables(
        treeParent: Phaser.GameObjects.Container,
        addToCollection: Phaser.GameObjects.GameObject[],
    ): void {
        treeParent.iterate(child => {
            if (child instanceof Phaser.GameObjects.Container) {
                this.GetCullables(child, addToCollection);
            }
            else {
                // getBounds is necessary to be cullable
                if (child.getBounds) {
                    addToCollection.push(child);
                }
            }
        });
    }
}